export const resolution = {
  layout: {
    positionHeaderVisible: 100,
    positionHeaderHidden: 0
  },
  detail: {
    positionListEpisodesUp:0,
    positionListEpisodesDown:550
  },
  carousel: {
    height: {
      mainMenu: 130,
      home: {
        live: 324
      },
      live: {
        live: 351
      }
    },
    width: {
      home: {
        live: 526
      },
      live: {
        live: 526
      },
    },
    slideMarginStart: {
      mainMenu: 135,
      episodeSelector: 240,
      homeLive: 80
    }
  },
  search: {
    positionNavigation: 385,
    positionNavigationAR: 515
  },
  grid: {
    fullCatalog: {
      columnCount: 5,
      columnWidth: 258,
      itemHeight: 324,
      rowHeight: 377
    },
    brands: {
      columnCount: 3,
      columnWidth: 425,
      itemHeight: 223,
      rowHeight: 276
    },
    columnCountInLogout: {
      columnCount: 4
    },
    search: {
      columnCount: 4,
      columnWidth: 258,
      itemHeight: 324,
      rowHeight: 377
    }
  },
  live : {
    rowHeight: 440
  }
};
